'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE_ID = exports.FILE_ID = ['fileId'];

var FILE_METADATA = exports.FILE_METADATA = ['fileMetadata'];

var THUMBNAIL_METADATA = exports.THUMBNAIL_METADATA = ['thumbnailMetadata'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/resolved-attachment/constants/resolvedAttachmentKeyPaths.js
// module id = 1119
// module chunks = 2 3